import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../utils/translate';
import Slider from './Slider';
import CarOverview from './CarOverview';
import './Home.css';

const Home = () => {
  const { language } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;

  const isActive = (path) => {
    return currentPath === path ? 'active' : '';
  };

  // 处理第三个广告栏点击事件
  const handleThirdPromotionClick = () => {
    navigate('/about');
  };

  // 推广栏数据
  const promotionItems = [
    {
      id: 1,
      image: '/images/advertisement1.jpg',
      titleKey: 'home.promotion.support24h',
      descriptionKey: 'home.promotion.support24hDesc'
    },
    {
      id: 2,
      image: '/images/advertisement2.jpg',
      titleKey: 'home.promotion.insurance',
      descriptionKey: 'home.promotion.insuranceDesc'
    },
    {
      id: 3,
      image: '/images/advertisement3.jpg',
      titleKey: 'home.promotion.easyBooking',
      descriptionKey: 'home.promotion.easyBookingDesc',
      onClick: handleThirdPromotionClick
    }
  ];

  return (
    <div className="home">
      <Slider />
      
      {/* 导航栏 - 放在 Slider 和 CarOverview 之间 */}
      <div className="page-navigation">
        <div className="nav-container">
          <Link to="/" className={`nav-link ${isActive('/')}`}>{t('nav.home', language)}</Link>
          <Link to="/about" className={`nav-link ${isActive('/about')}`}>{t('nav.about', language)}</Link>
          <Link to="/guide" className={`nav-link ${isActive('/guide')}`}>{t('nav.guide', language)}</Link>
          <Link to="/shop" className={`nav-link ${isActive('/shop')}`}>{t('nav.shop', language)}</Link>
        </div>
      </div>
      
      {/* 推广栏模块 */}
      <div className="promotion-section">
        <div className="promotion-container">
          {promotionItems.map((item) => (
            <div 
              key={item.id} 
              className="promotion-card"
              onClick={item.onClick || undefined}
              style={item.onClick ? { cursor: 'pointer' } : {}}
            >
              <div className="promotion-image">
                <img 
                  src={item.image} 
                  alt={t(item.titleKey, language)}
                  onError={(e) => {
                    e.target.src = '/images/placeholder.png';
                  }}
                />
              </div>
              <div className="promotion-content">
                <h3 className="promotion-title">{t(item.titleKey, language)}</h3>
                <p className="promotion-description">{t(item.descriptionKey, language)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <CarOverview />
    </div>
  );
};

export default Home;
